module.exports = __webpack_public_path__ + "site/img/148.c712fea4.jpg";